window.showTips=function(){
    
};